module.exports = function() {
  return {
    $get: ['$q',
      function($q) {
        function Notify(options) {
          const defaults = {
            positionClass: 'notify-bottom-center',
            disappear: true, // 提示框是否消失
            duration: 1500, //  提示框在显示之后多少毫秒消失
            fadeOut: true // 是否渐变消失
          }
          if (arguments[0] && typeof arguments[0] === 'object') {
            this.options = extendDefaults(defaults, arguments[0])
          }
          this.init()
        }

        Notify.prototype.init = function() {
          const options = this.options
          this.id = (new Date()).getTime()
          this.notifyElement = createNotifyHtml(this.id, options)
          insetHtml(this.notifyElement, options)
          if (options.duration && options.disappear) {
            this.hide()
          }
        }

        Notify.prototype.show = function(message) {
          const notify = this
          const options = notify.options || {}
          const notifyElement = notify.notifyElement

          if (notify.hideTimeOut) {
            clearTimeout(notify.hideTimeOut)
          }
          if (notify.fadeOutTimeOut) {
            clearTimeout(notify.fadeOutTimeOut)
          }
          if (message) {
            notifyElement.querySelectorAll('.ui-notify-tips')[0].innerHTML = message
          }
          if (notifyElement) {
            removeClass(notifyElement, 'fadeOut')
            removeClass(notifyElement, 'hide')
            if (options.duration && options.disappear) {
              notify.hide()
            }
          }
        }

        Notify.prototype.hide = function() {
          const notify = this
          const options = notify.options || {}
          const notifyElement = notify.notifyElement
          notify.hideTimeOut = setTimeout(function() {
            if (notifyElement) {
              if (options.fadeOut) {
                notify.fadeOut().then(function() {
                  //  先执行完fadeOut再hide
                  addClass(notifyElement, 'hide')
                })
              } else {
                addClass(notifyElement, 'hide')
              }
            }
          }, options.duration || 0)
        }

        Notify.prototype.fadeOut = function() {
          const notify = this
          const options = notify.options || {}
          const defer = $q.defer()
          const notifyElement = notify.notifyElement
          addClass(notifyElement, 'fadeOut')
          notify.fadeOutTimeOut = setTimeout(function() {
            defer.resolve(notify)
          }, options.duration || 0)
          return defer.promise
        }

        Notify.prototype.destroy = function() {
          // 1、如果通知栏中还有其他信息，则删除当前消息。
          // 2、 如果通知栏中只有当前一个消息，则删除整个通知栏
          const notify = this
          const notifyBoard = notify.notifyElement.parentNode

          if (notify.hideTimeOut) {
            clearTimeout(notify.hideTimeOut)
          }
          if (notify.fadeOutTimeOut) {
            clearTimeout(notify.fadeOutTimeOut)
          }
          if (notifyBoard.querySelectorAll('.ui-notify').length > 1) {
            notify.notifyElement.remove()
          } else {
            notifyBoard.remove()
          }
        }

        function extendDefaults(source, properties) {
          let property
          for (property in properties) {
            if (properties.hasOwnProperty(property)) {
              source[property] = properties[property]
            }
          }
          return source
        }

        function createNotifyHtml(id, options) {
          const tipClass = options.tipClass || ''
          const notifyElement = document.createElement('div')
          notifyElement.id = 'notify-' + id
          notifyElement.className = 'ui-notify'
          notifyElement.innerHTML = '<span class="ui-notify-tips ' + tipClass + '">' + options.message + '</span>'

          return notifyElement
        }

        function insetHtml(notifyElement, options) {
          // 1、 有指定通知信息的位置,如果DOM中有相同位置的通知栏，则将通知信息放在该通知栏中
          // 2、 有指定通知信息的位置，但是DOM中没有该通知栏则创建该位置的通知栏
          // 3、没有指定通知信息的位置，则使用默认通知栏

          const positionClass = options.positionClass
          const boards = document.querySelectorAll('.ui-notify-board' + '.' + positionClass)
          let boardElement

          if (boards.length > 0) {
            boardElement = boards[0]
          } else {
            boardElement = document.createElement('div')
            boardElement.className = 'ui-notify-board ' + positionClass
          }

          boardElement.appendChild(notifyElement)
          document.body.appendChild(boardElement)
        }

        function hasClass(el, className) {
          if (el.classList) {
            return el.classList.contains(className)
          } else {
            return !!el.className.match(new RegExp('(\\s|^)' + className + '(\\s|$)'))
          }
        }

        function addClass(el, className) {
          if (el.classList) {
            el.classList.add(className)
          } else if (!hasClass(el, className)) {
            el.className += ' ' + className
          }
        }

        function removeClass(el, className) {
          if (el.classList) {
            el.classList.remove(className)
          } else if (hasClass(el, className)) {
            const reg = new RegExp('(\\s|^)' + className + '(\\s|$)')
            el.className = el.className.replace(reg, ' ')
          }
        }

        const notify = {
          set: function (options) {
            if (notify.instance) {
              notify.instance.show(options.message)
            } else {
              notify.instance = new Notify(options)
            }
          }
        }

        return notify
      }
    ]
  }
}



// WEBPACK FOOTER //
// ./src/js/infrastructure/utils/notify.js